// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"6ba870cb","250":"2a1dbf09","407":"dd8b8fe0","424":"2a124967","436":"38be8ed9","453":"f394a27d","455":"2b9dbaca","501":"8af48f40","595":"6d993476","606":"6816e9c4","691":"15be4877","821":"2afa21d7","925":"0c36a418","969":"3f767750"}[chunkId] + ".chunk.js";
};